import { CreditNoteHeaderSearchCriteria, EMPTY_CREDIT_NOTE_HEADER_SEARCH_CRITERIA } from "domain/entity/CreditNote/CreditNoteHeaderSearchCriteria";
import { RequisitionFormEntity } from "domain/entity/RequisitionForm/RequisitionFormEntity";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import { customEventListener, E_Custom_Dispatch_Event, E_Type_Of_Event } from "helpers/Events";
import moment from "moment";
import { hdrStateDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useCreditNoteHeaderVM } from "presentation/hook/CreditNote/useCreditNoteHeaderVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCreditNoteHeaderMaintenanceTracked } from "presentation/store/CreditNote/CreditNoteHeaderMaintenanceProvider";
import { memo, useCallback, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import CreditNoteHeaderTitleBar from "./CreditNoteHeaderTitleBar";
import CreditNoteHeaderSearchPanel from "./Header/LeftPanel/CreditNoteHeaderSearchPanel";
import CreditNoteHeaderTablePanel from "./Header/Table/CreditNoteHeaderTablePanel";

const CreditNoteHeaderMaintenance: React.FC = () => {
    const [creditNoteHeaderState] = useCreditNoteHeaderMaintenanceTracked();
    const { isShowCriteriaPanel, isBackFromDetail, searchCriteria } = creditNoteHeaderState;
    const creditNoteHeaderVM = useCreditNoteHeaderVM();
    const [isLoading, setIsLoading] = useState(false);
    const [anaInfoState] = useANAInfoTracked();
    const [isInitialScreen, setIsInitialScreen] = useState<boolean>(false);

    const initialScreen = useCallback(async () => {
        setIsLoading(true);
        setIsInitialScreen(true);

        let newSearchCriteria = null;
        if (isBackFromDetail) {
            newSearchCriteria = { ...searchCriteria };
        } else {
            newSearchCriteria = { ...EMPTY_CREDIT_NOTE_HEADER_SEARCH_CRITERIA }
            newSearchCriteria = {
                ...newSearchCriteria,
                createdDateFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                createdDateTo: moment().endOf("day").toDate(),
                createdBy: anaInfoState.userName,
                states: hdrStateDropdownOption?.filter(option => option.value === "NIL")?.map(option => option.value)
            };
        }

        try {
            await Promise.allSettled([
                creditNoteHeaderVM.loadDropdownOption(),
                creditNoteHeaderVM.getCreditNoteHeaders(newSearchCriteria),
            ]).then(data => {
                setIsLoading(false);
            }).catch(e => {
                setIsLoading(false);
                setIsInitialScreen(false);
            })
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }, [anaInfoState.userName, creditNoteHeaderVM, isBackFromDetail, searchCriteria]);

    const initialRedirectScreen = useCallback(async (reqFormEty: RequisitionFormEntity) => {
        if (!reqFormEty) return;
        setIsLoading(true);
        setIsInitialScreen(true);

        let searchCriteria: CreditNoteHeaderSearchCriteria = {
            ...EMPTY_CREDIT_NOTE_HEADER_SEARCH_CRITERIA,
            reqNoFrom: reqFormEty.reqFormNo, reqNoTo: reqFormEty.reqFormNo
        };
        await Promise.allSettled([
            creditNoteHeaderVM.loadDropdownOption(),
            creditNoteHeaderVM.getCreditNoteHeaders({ ...searchCriteria }).then((data) => {
                setIsLoading(false);
            }).catch(error => {
                setIsLoading(false);
                setIsInitialScreen(false);
            }).finally(() => {
                localStorage.removeItem(E_Custom_Dispatch_Event.REDIRECT_CREDIT_NOTE_HEADER_MAINTENANCE);
            })
        ]).catch(error => {
            setIsLoading(false);
            setIsInitialScreen(false);
            localStorage.removeItem(E_Custom_Dispatch_Event.REDIRECT_CREDIT_NOTE_HEADER_MAINTENANCE);
        }).finally(() => {
            setIsLoading(false);
        });


    }, [creditNoteHeaderVM])

    useEffect(() => {
        const onCreditNoteMaintRedirect = async (e: any) => {
            switch (e.detail.action) {
                case E_Custom_Dispatch_Event.REDIRECT_CREDIT_NOTE_HEADER_MAINTENANCE:
                    const searchCriteria = (e.detail.data.data as RequisitionFormEntity);
                    localStorage.setItem(E_Custom_Dispatch_Event.REDIRECT_CREDIT_NOTE_HEADER_MAINTENANCE, JSON.stringify(searchCriteria));
                    setIsInitialScreen(false);

                    break;
            }
        }

        customEventListener(E_Type_Of_Event.CREDIT_NOTE_MAINT_REDIRECT_EVENT_INITIAL, onCreditNoteMaintRedirect);
    }, []);

    useEffect(() => {
        const tempSearchCriteria = localStorage.getItem(E_Custom_Dispatch_Event.REDIRECT_CREDIT_NOTE_HEADER_MAINTENANCE) ?
            JSON.parse(localStorage.getItem(E_Custom_Dispatch_Event.REDIRECT_CREDIT_NOTE_HEADER_MAINTENANCE) ?? "") as RequisitionFormEntity :
            null;

        if (!tempSearchCriteria) {
            if (isInitialScreen && !isBackFromDetail) return;
            creditNoteHeaderVM.setIsSearchLoading(true);

            initialScreen().then((data) => {
                setIsLoading(false);
                creditNoteHeaderVM.setIsSearchLoading(false);
            }).catch(error => {
                setIsLoading(false);
                creditNoteHeaderVM.setIsSearchLoading(false);
            });
        } else {
            !isInitialScreen && initialRedirectScreen(tempSearchCriteria).then((data) => {
                setIsLoading(false);
                creditNoteHeaderVM.setIsSearchLoading(false);
            }).catch(error => {
                setIsLoading(false);
                creditNoteHeaderVM.setIsSearchLoading(false);
            });
        }
    }, [creditNoteHeaderVM, initialRedirectScreen, initialScreen, isBackFromDetail, isInitialScreen])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>

        <div className={`main-comp-wrapper${isShowCriteriaPanel ? '' : ' im-hide-side-form-draggable'}`}>
            <CreditNoteHeaderTitleBar />

            <SliderPanel
                isOpen={true}
                draggable={true}
                leftSectionWidth={isShowCriteriaPanel ? "25%" : "0%"}
                rightSectionWidth={isShowCriteriaPanel ? "75%" : "100%"}
                leftChildren={<CreditNoteHeaderSearchPanel />}
                rightChildren={<CreditNoteHeaderTablePanel />}
            />
        </div>
    </>
}
export default memo(CreditNoteHeaderMaintenance);